import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['source', 'entityType'])}` : '';
  const searchActivities = `searchActivities(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchActivities} {
        id
        userId
        entityType
        action
        source
        activityDate
      }
    }
  `;
};
